// telemetry.api.ts
// POST /api/telemetry/errors — remonte une erreur backoffice vers l'observabilité
// centrale (Serilog structuré + base de connaissance TRACE). Requiert un bearer
// Azure AD valide (géré par l'intercepteur apiClient). Retourne 204 sans contenu.

import type { TelemetryErrorReport } from "@/domain/types/telemetry";

import apiClient from "./client";

export async function postErrorReport(
  report: TelemetryErrorReport,
): Promise<void> {
  await apiClient.post("/api/telemetry/errors", report);
}
